export const secondToStringTime = (second: number) => {
  const minutes = Math.floor((second % 3600) / 60);
  const seconds = Math.floor(second % 60);

  return `${minutes}:${`${String(seconds).padStart(2, '0')}`}`;
};
